// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"6c3306dc","453":"262430d7"}[chunkId] + ".chunk.js";
};